/**
 * Копирование текста в буфер обмена.
 *
 * Современный путь — `navigator.clipboard.writeText`, он доступен только на
 * защищённом origin и по жесту пользователя. Запасной — скрытое поле и
 * `document.execCommand('copy')`: работает по http и в старых WebView. Функцию
 * нужно вызывать прямо из обработчика клика или клавиши, иначе браузер откажет.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    // Падаем в запасной путь: отказ на уровне разрешений не значит, что нельзя
    // скопировать выделением.
  }
  return legacyCopy(text)
}

function legacyCopy(text: string): boolean {
  if (typeof document === 'undefined' || !document.body) return false
  const field = document.createElement('textarea')
  field.value = text
  field.setAttribute('readonly', '')
  field.style.position = 'fixed'
  field.style.top = '0'
  field.style.left = '-9999px'
  field.style.opacity = '0'
  const previous = document.activeElement as HTMLElement | null
  document.body.appendChild(field)
  try {
    field.focus()
    field.select()
    field.setSelectionRange(0, text.length)
    return typeof document.execCommand === 'function' ? document.execCommand('copy') : false
  } catch {
    return false
  } finally {
    document.body.removeChild(field)
    previous?.focus?.()
  }
}
